export default __webpack_public_path__ + "static/media/megaphone.d06eccc6.svg";